import DateFnsUtils from '@date-io/date-fns';
import {
  Card, CardContent,
  CircularProgress,
  createTheme, Divider,
  Grid,
  IconButton,
  List, ListItem,
  ListItemSecondaryAction,
  ListItemText, Paper, Select, Typography
} from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import PersonIcon from '@material-ui/icons/Person';
import SearchIcon from '@material-ui/icons/Search';
import StorefrontIcon from '@material-ui/icons/Storefront';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import clsx from 'clsx';
import 'date-fns';
import trLocale from "date-fns/locale/tr";
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getUser } from 'src/utils/Common';

const useStyles = makeStyles((theme) => ({
  root: {},
  Onay: {
    Color: green[500],
  },
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1150
  },
  methodCell: {
    width: 100
  },
  statusCell: {
    width: 64
  },
  baslik: {
    padding: theme.spacing(1)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  addIcon: {
    marginRight: theme.spacing(1)
  },
  done: {
    textDecoration: 'line-through',
    color: theme.palette.text.secondary
  },
  search: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon
  },
  searchInput: {
    flexGrow: 1
  },
  searchButton: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  },

  redColor: {
    color: '#FF0000'
  },
}));

const materialTheme = createTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    },
  },
});
const localeMap = {
  tr: trLocale,
};
function Todos({ className, warehouseProduct, getWarehouseProducts }) {
  const classes = useStyles();
  const [todosAdet, setTodosAdet] = useState(0);
  const [todosData, setTodosData] = useState([]);
  const today = moment(new Date()).format('YYYY-MM-DD');
  const [baslangicTarihi, setBaslangicTarihi] = React.useState(today);
  const [bitisTarihi, setBitisTarihi] = React.useState(today);
  const [stateGun, setStateGun] = useState("0");
  const [stateGunTeknisyen, setStateGunTeknisyen] = useState("0");
  const [stateGunDepo, setstateGunDepo] = useState("-1");

  let DepoTakipData = [];
  DepoTakipData = warehouseProduct.data.filter(d => parseInt(d.DEPO_TAKIP) === parseInt(1));
  const key = 'KUL_BAYI_KODU';
  const uniqueDepoTakipData = [...new Map(DepoTakipData.map(item =>
    [item[key], item])).values()];

  // uniqueDepoTakipTeknisyenData removed (unused)

  const keyDepo = 'DEPO_TIPI';
  const uniqueDepoTakipDataDepo = [...new Map(DepoTakipData.map(item =>
    [item[keyDepo], item])).values()];


  const handleChangeBayi = (value) => {
    setStateGun(value);
    if (value === "0") {
      if (stateGunTeknisyen === "0") {
        DepoTakipData = warehouseProduct.data.filter(d => parseInt(d.DEPO_TAKIP) === parseInt(1));
      } else {
        DepoTakipData = warehouseProduct.data.filter(d => parseInt(d.DEPO_TAKIP) === parseInt(1) && d.TEKNISYEN_KODU === parseInt(stateGunTeknisyen));
      }
    } else {
      if (stateGunTeknisyen === "0") {
        DepoTakipData = warehouseProduct.data.filter(d => parseInt(d.DEPO_TAKIP) === parseInt(1) && d.KUL_BAYI_KODU === value);
      } else {
        DepoTakipData = warehouseProduct.data.filter(d => parseInt(d.DEPO_TAKIP) === parseInt(1) && d.KUL_BAYI_KODU === value && d.TEKNISYEN_KODU === parseInt(stateGunTeknisyen));
      }
    }
    setTodosData(DepoTakipData);
  };

  const handleChangeTeknisyen = (value) => {
    setStateGunTeknisyen(value);
    if (value === "0") {
      if (stateGun === "0") {
        DepoTakipData = warehouseProduct.data.filter(d => parseInt(d.DEPO_TAKIP) === parseInt(1));
      } else {
        DepoTakipData = warehouseProduct.data.filter(d => parseInt(d.DEPO_TAKIP) === parseInt(1) && d.KUL_BAYI_KODU === stateGun);
      }
    } else {
      if (stateGun === "0") {
        DepoTakipData = warehouseProduct.data.filter(d => parseInt(d.DEPO_TAKIP) === parseInt(1) && d.TEKNISYEN_KODU === parseInt(value));
      } else {
        DepoTakipData = warehouseProduct.data.filter(d => parseInt(d.DEPO_TAKIP) === parseInt(1) && d.TEKNISYEN_KODU === parseInt(value) && d.KUL_BAYI_KODU === stateGun);
      }
    }
    setTodosData(DepoTakipData);
  };


  const handleChangeDepo = (value) => {
    setstateGunDepo(value);
    DepoTakipData = warehouseProduct.data.filter(d => parseInt(d.DEPO_TAKIP) === parseInt(1)
      && (d.DEPO_TIPI === parseInt(value) || -1 === parseInt(value))
      && (d.KUL_BAYI_KODU === stateGun || parseInt(stateGun) === 0)
      && (d.TEKNISYEN_KODU === stateGunTeknisyen || parseInt(stateGun) === 0)
    );


    setTodosData(DepoTakipData);
  };

  const SessionUser = getUser();


  const handleDateChange = (event, type) => {
    var Deger = moment(event).format('YYYY-MM-DD');
    type === 1 ? setBaslangicTarihi(Deger) : setBitisTarihi(Deger);
  };

  useEffect(() => {
    setTodosAdet(warehouseProduct.data.length);
    setTodosData(warehouseProduct.data);
    handleChangeBayi(stateGun);
    handleChangeTeknisyen(stateGunTeknisyen);
    // eslint-disable-next-line
  }, [warehouseProduct.data]);

  const handleTarihSorgula = () => {
    getWarehouseProducts(new Date(baslangicTarihi).toLocaleDateString().split('/').join('.'), new Date(bitisTarihi).toLocaleDateString().split('/').join('.'));
  }

  return (
    <div>

      <div className={clsx(classes.root, className)}>
        <Card>
          <Paper
            className={classes.search}
            elevation={1}>
            <PersonIcon className={classes.searchIcon} />
            <Select
              native
              value={stateGunTeknisyen}
              onChange={e => handleChangeTeknisyen(e.target.value)}
              disableUnderline
              className={classes.searchInput}
              label="Teknisyen">
              <option value={SessionUser.TechnicianCode}>{SessionUser.TechnicianCode + ' - ' + SessionUser.NameSurname}</option>
            </Select>
          </Paper>
          <Paper
            className={classes.search}
            elevation={1}>
            <StorefrontIcon className={classes.searchIcon} />
            <Select
              native
              value={stateGun}
              onChange={e => handleChangeBayi(e.target.value)}
              disableUnderline
              className={classes.searchInput}
              label="Bayi">
              <option value="0">Tüm Bayiler</option>
              {uniqueDepoTakipData.map(p => {
                return <option key={p.KUL_BAYI_KODU} value={p.KUL_BAYI_KODU}>{p.KUL_BAYI_KODU}-{p.BAYI_ACIKLAMA}-{p.BAYI_MARKA}</option>
              })}
            </Select>
          </Paper>
          <Paper
            className={classes.search}
            elevation={1}>
            <HomeWorkIcon className={classes.searchIcon} />
            <Select
              native
              value={stateGunDepo}
              onChange={e => handleChangeDepo(e.target.value)}
              disableUnderline
              className={classes.searchInput}
              label="Depo">
              <option value="-1">Tüm Depolar</option>
              {uniqueDepoTakipDataDepo.map(p => {
                return <option key={p.DEPO_TIPI} value={p.DEPO_TIPI}>{p.DEPO}</option>
              })}
            </Select>
          </Paper>
          {
            warehouseProduct.loading ?
              <CircularProgress color="primary" />
              : <div></div>
          }
          <CardContent className={classes.content}>
            <List className={classes.root}>
              <ListItem>
                <Typography variant="h6" gutterBottom>
                  Bugüne randevulu <b style={{ color: '#FF0000' }}>{todosAdet}</b> adet nakliyeli iş emri var. Teslim/kurulum yapılanlar bu listede gösterilmez.
                </Typography>
                <ListItemSecondaryAction>
                  <IconButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleTarihSorgula()}                  >
                    <SearchIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
              <ListItem>
                <Grid container spacing={1}>
                  <Grid item xs={6} sm={6}>
                    <ThemeProvider theme={materialTheme}>
                      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap["tr"]}>
                        <KeyboardDatePicker
                          color="primary"
                          inputVariant="outlined"
                          label={'Başlangıç Tarihi'}
                          invalidDateMessage={'Hatalı Tarih Formatı'}
                          format={'dd.MM.yyyy'}
                          variant="outlined"
                          value={baslangicTarihi}
                          onChange={e => handleDateChange(e, 1)}
                          KeyboardButtonProps={{
                            'aria-label': 'change date',
                          }}
                        />
                      </MuiPickersUtilsProvider>
                    </ThemeProvider>
                  </Grid>
                  <Grid item xs={6} sm={6}>
                    <ThemeProvider theme={materialTheme}>
                      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap["tr"]}>
                        <KeyboardDatePicker
                          color="primary"
                          inputVariant="outlined"
                          label={'Bitiş Tarihi'}
                          invalidDateMessage={'Hatalı Tarih Formatı'}
                          format={'dd.MM.yyyy'}
                          variant="outlined"
                          value={bitisTarihi}
                          onChange={e => handleDateChange(e, 2)}
                          KeyboardButtonProps={{
                            'aria-label': 'change date',
                          }}
                        />
                      </MuiPickersUtilsProvider>
                    </ThemeProvider>
                  </Grid>
                </Grid>
              </ListItem>
            </List>
            <Divider className={classes.divider} />
            <List className={classes.root}>
              {todosData.map(log => (
                <div key={log.FisNo}>
                  <ListItem alignItems="flex-start">
                    <ListItemText>
                      <Typography variant="body1" gutterBottom>
                        <b>Teknisyen : </b>
                        {log.KUL_TEK_KODU}-{log.TEKNISYEN}
                      </Typography>
                      <Typography variant="body1" gutterBottom>
                        <b>Bayi : </b>
                        {log.KUL_BAYI_KODU}-{log.BAYI_ACIKLAMA}-{log.BAYI_MARKA}
                      </Typography>
                      <Typography variant="body1" gutterBottom>
                        <b>Marka-Ürün : </b>
                        {log.MARKA}-{log.KUL_MODEL_KODU}-{log.MODEL}
                      </Typography>
                      <Typography variant="body1" gutterBottom>
                        <b>Depo : </b>
                        {log.DEPO}-{log.DEPO_ADRES}
                      </Typography>
                      <Typography variant="body1" gutterBottom>
                        <b>Müşteri : </b>
                        {log.Musteri}
                      </Typography>
                      <Typography variant="body1" gutterBottom>
                        <b>Ürün Durum : </b>
                        {log.KABUL_DURUM}
                      </Typography>

                    </ListItemText>
                  </ListItem>
                  <Divider className={classes.divider} />
                </div>
              ))}
            </List>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
export default connect(
  state => ({ warehouseProduct: state.warehouseProductReducer }),

)(Todos);
